module.exports = __webpack_public_path__ + "ipetbooking/admin/img/ga_1.33e7e70e.jpg";